<template>
  <b-card
    :no-body="respondents.length > 0"
    :header="titleHeader"
    header-bg-variant="primary"
    header-text-variant="white"
    class="mb-4">
    <b-list-group v-if="respondents.length > 0">
      <b-list-group-item
        v-for="respondent in top5Respondents"
        :key="respondent.userId"
        :class="borderClassByRole(respondent)">
        <b-row>
          <b-col class="ellipsis">
            {{respondent.name}}
            <p v-if="!respondent.responseData.responded && respondent.responseData.lastNotifiedDate"
              class="card-text small text-muted">
              Last reminded: {{formatDate(respondent.responseData.lastNotifiedDate)}}
            </p>
          </b-col>
          <b-col v-if="!respondent.responseData.responded  && respondent.sendSurvey"
            cols="4" align-self="end">
            <b-button
              @click="sendReminder(respondent)"
              :disabled="respondent.sent || respondent.isLoading"
              class="float-right"
              style="width:82px;">
              <b-spinner small v-if="respondent.isLoading" label="Spinning"></b-spinner>
              <div v-else>{{respondent.sent ? "Sent!" : "Remind"}}</div>
            </b-button>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <template v-if="respondents.length > 5" v-slot:footer>
      <b-link @click="showModal('more-pending-modal')">Show all</b-link>
      <b-modal
        ref="more-pending-modal"
        :title="title"
        ok-only
        ok-title="Close">
        <b-list-group v-if="respondents.length > 0">
          <b-list-group-item
            v-for="respondent in respondents"
            :key="respondent.userId"
            :class="borderClassByRole(respondent)">
            <b-row>
              <b-col class="ellipsis">{{respondent.name}}</b-col>
              <b-col v-if="!respondent.responseData.responded && respondent.sendSurvey"
                align-self="end">
                <b-button
                  @click="sendReminder(respondent)"
                  :disabled="respondent.sent || respondent.isLoading"
                  class="float-right"
                  style="width:80px;">
                  <b-spinner small v-if="respondent.isLoading" label="Spinning"></b-spinner>
                  <div v-else>{{respondent.sent ? "Sent!" : "Remind"}}</div>
                </b-button>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-modal>
    </template>
    <b-card-text v-if="!(respondents.length > 0)">
      <p>{{noneText}}</p>
    </b-card-text>
  </b-card>
</template>

<script>
import axios from "axios";

export default {
  props: {
    respondents: Array,
    projectName: String,
    title: String,
    noneText: {type: String, default: "No pending responses!"},
    showRemainingCount: Boolean
  },
  data() {
    return {
      errors: []
    };
  },
  methods: {
    showModal(name) {
      this.$refs[name].show();
    },
    showModalVFor(name) {
      this.$refs[name][0].show();
    },
    sendReminder(respondent) {
      respondent.isLoading = true;

      axios
        .post(`${this.$api_url}/notification/send?remind=true`,
          {
            userId: respondent.userId,
            projectName: this.projectName,
            responseId: respondent.responseData.responseId
          },
          this.getReqConfig()
        )
        .then(() => {
          respondent.responseData.lastNotifiedDate = "Today";
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() =>{
          respondent.isLoading = false;
          respondent.sent = true;
        });
    },
    formatDate(date){
      if (date === "Today"){
        return date;
      }

      return this.$helpers.displayDate(new Date(date));
    },
    borderClassByRole(respondent) {
      if (respondent.role == "Owner") {
        return "border-owner";
      } else if (respondent.role == "Contractor") {
        return "border-contractor";
      } else {
        return "";
      }
    }
  },
  computed: {
    top5Respondents() {
      return this.respondents.slice(0, 5);
    },
    titleHeader() {
      var header = this.title;

      if (this.showRemainingCount) {
        let count = this.respondents.length;
        header += `${count > 0 ? ` (${count} left)` : ""}`;
      }

      return header;
    }
  }
};
</script>
<style scoped>
.border-owner {
  border-left-width: 6px;
  border-left-color: #4a708b;
}
.border-contractor {
  border-left-width: 6px;
  border-left-color: #34bf1b;
}
.scroll {
  max-height: 190px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>